import { render } from "./home.vue?vue&type=template&id=4b01a7fe"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import exportComponent from "/Users/voltz/Documents/Github/Website/Marketplaces-prompts/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__